/* eslint-disable */
import { createPresetsFactory } from '@salsita-ai/platform-project-sdk/domain'

import { AnyDomainEntity, ApronNone, BenchBasic, BrewerBase, RectangleTop, RootEntity, Table } from './model/index.js'

export const createPresets = createPresetsFactory<AnyDomainEntity, RootEntity>()

export const generatedPresets = createPresets([
  {
    name: 'Default',
    description: 'Default preset',
    rootEntityType: 'Table',
    initialDomainEntities: [
      {
        id: 'Table-1' as Table['id'],
        type: 'Table',
        topId: 'RectangleTop-1' as RectangleTop['id'],
        baseStyleId: 'BrewerBase-1' as BrewerBase['id'],
        benchId: 'BenchBasic-1' as BenchBasic['id'],
        baseType: 'Pedestal',
        woodSpecies: 'Hickory',
        sheen: 'Flat',
        seatingType: 'NoSeating',
        seatingAmount: 0,
      },
      {
        id: 'RectangleTop-1' as RectangleTop['id'],
        type: 'RectangleTop',
        length: 84,
        width: 42,
        thickness: 1.75,
        thicknessType: 'Standard',
        edgeStyle: 'Clean',
        distressLevel: 'Clean',
        finish: 'NaturalTone',
        withGrooves: false,
        withCornerRadius: false,
        leafType: 'NoLeaf',
        leafAmount: 0,
        apronId: 'ApronNone-1' as ApronNone['id'],
      },
      {
        id: 'BrewerBase-1' as BrewerBase['id'],
        type: 'BrewerBase',
        hasCrossbrace: false,
        finish: 'EbonyTone',
      },
      {
        id: 'ApronNone-1' as ApronNone['id'],
        type: 'ApronNone',
      },
      {
        id: 'BenchBasic-1' as BenchBasic['id'],
        type: 'BenchBasic',
      },
    ],
  },
])
